import React from 'react';

import { Table as AntTable, TableProps } from 'antd';

import {
  SELECTION_ALL,
  SELECTION_INVERT,
  SELECTION_NONE,
} from 'antd/lib/table/hooks/useSelection';

import { DraggableTable } from './Table.Draggable';
import { TableSummary } from './TableSummary';
import { TableColumn } from './TableColumn';
import { TableColumnGroup } from './TableColumnGroup';

const Table = <RecordType extends object>(props: TableProps<RecordType>) => {
  return <AntTable {...props} />;
};

Table.Column = TableColumn;
Table.ColumnGroup = TableColumnGroup;
Table.Summary = TableSummary;
Table.SELECTION_ALL = SELECTION_ALL;
Table.SELECTION_INVERT = SELECTION_INVERT;
Table.SELECTION_NONE = SELECTION_NONE;
Table.Draggable = DraggableTable;

export { Table };
